import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AllocationViewFacade } from '../allocation-view.facade';

@Injectable({
  providedIn: 'root',
})
export class AllocationViewGuard {
  constructor(private allocationViewFacade: AllocationViewFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    this.allocationViewFacade.selectSavedViewMode();
    return true;
  }
}
